import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.checkliste-detail';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenChecklisteDetailEffects {

    ChecklisteDetail$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_CHECKLISTE_DETAIL),
        mergeMap((x: ac.GetChecklisteDetailAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getChecklisteDetail(x.checkliste_id).pipe(
                map((result: any) => {
                    return new ac.GetChecklisteDetailErfolgreichAction(result, x.checkliste_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetChecklisteDetailFehlerAction(error, x.checkliste_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ChecklisteQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ChecklisteQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ChecklisteQueryService);
        }
        return this.service;
    }
}
